<template>
  <div>
    <div class="row no-gutters mt-2 ml-2 mr-2" v-for="event in eventList">
      <div class="col-md-12">

        <!-- Edit Mode -->
        <div class="card pl-2 pr-2" v-if="editModeEnabled">
          <div class="row">
            <div class="col-10">
              {{ event.name }}
            </div>
            <div class="col-2 text-right">
              <span class="text-danger pointer" @click="openDeleteConfirmation(event)">
                <i class="fa fa-trash"></i>
              </span>
            </div>
          </div>
        </div>

        <!-- Normal Mode -->
        <div class="card pl-2 pr-2"
             @dblclick="clickedOnEvent(event)"
             :class="{cardActive: getEventToApplyHoverEffect === event}"
             v-on:mouseover="activeEvent = event"
             v-on:mouseleave="activeEvent = null"
              v-else>
          {{ event.name }}
        </div>

      </div>
    </div>


    <!-- Delete Event Confirmation Modal-->
    <sweet-modal :title="$t('UI_INSTANCE_EVENT_DELETE_MODAL_TITLE')" ref="deleteEventConfirmationModal"
                 class="text-left" v-on:close="eventToDelete = null">
      {{ $t('UI_INSTANCE_EVENT_DELETE_MODAL_TEXT', {name: this.eventToDelete !== null ? this.eventToDelete.name : ''})
      }}

      <div slot="button">
        <button class="btn btn-danger" @click="deleteEvent">
          {{ $t('UI_MODAL_BUTTON_DELETE') }}
        </button>
        <button class="btn btn-secondary ml-1" @click="$refs.deleteEventConfirmationModal.close()">
          {{ $t('UI_MODAL_BUTTON_CLOSE') }}
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

const EventRepository = RepositoryFactory.get('events');
const ChapterLiveRepository = RepositoryFactory.get('chaptersLive');
const ChapterRepository = RepositoryFactory.get('chapters');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'EventColumn',
  components: { SweetModal },
  props: ['eventList', 'type'],
  data() {
    return {
      activeEvent: null,
      eventToDelete: null,
    };
  },
  methods: {
    clickedOnEvent(event) {
      // If an entry is Selected -> Replace/Append the event to it.
      // Works in both post & live mode
      if (this.$store.getters.getSelectedChapterId !== null && this.$store.getters.getSelectedEntryId !== null) {
        return this.appendEventToSelectedEntry(event);
      }
      // There is no entry selected. -> Add a new entry based on the event
      // Works only in live mode.

      if (this.$store.getters.instanceInLiveMode) {
        return this.insertChapterFromEvent(event);
      }
      return false;


      return false;
    },
    insertChapterFromEvent(event) {
      if (!this.$store.getters.instanceInLiveMode) {
        return false;
      }

      ChapterLiveRepository.insertChapterFromEvent(event.id)
        .then((res) => {
          InstanceRepository.refetchActive(false);
        });
    },
    /**
			 * Appends/Replaces the selected entry with the  event provided.
			 *
			 * @param event
			 * @returns {boolean}
			 */
    appendEventToSelectedEntry(event) {
      if (this.$store.getters.editModeEnabled) {
        return false;
      }

      if (this.$store.getters.getSelectedChapterId === null || this.$store.getters.getSelectedEntryId === null) {
        return false;
      }

      ChapterRepository.appendEntryWithEvent(this.$store.getters.getSelectedChapterId, this.$store.getters.getSelectedEntryId, event.id)
        .then(() => {
          InstanceRepository.refetchActive(false);
        });
    },


    openDeleteConfirmation(event) {
      this.eventToDelete = event;
      this.$refs.deleteEventConfirmationModal.open();
    },
    deleteEvent() {
      if (this.eventToDelete === null) {
        return false;
      }

      EventRepository.delete(this.eventToDelete.id)
        .then((res) => {
          this.$snotify.info(this.$t('UI_INSTANCE_EVENT_DELETED', { name: this.eventToDelete.name }));
          EventRepository.refetchList();
          this.$refs.deleteEventConfirmationModal.close();
        });
    },
  },
  computed: {
    editModeEnabled() {
      return this.$store.getters.instanceGroupEditEnabled;
    },
    getEventToApplyHoverEffect() {
      if (this.$store.getters.getSelectedChapterId === null && this.$store.getters.getSelectedEntryId === null) {
        	if (!this.$store.getters.instanceInLiveMode) { return false; }
      }

      return this.activeEvent;
    },
  },
};
</script>

<style scoped>
  .cardActive {
    background-color: #00a6d4;
    color: white;
    cursor: pointer;
  }
</style>
